
import Bold from "../../../assets/outline/Bold.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BoldIcon({ className, dataTestid = "BoldIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Bold data-testid={dataTestid} className={classes} {...rest} />
  );
}
